import {useEffect, useState} from 'react';
import AccountStore from 'src/stores/AccountStore';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {getDescriber as getDescriberCommon} from './descriptors/campusComponents/DescriptorType';
import {getDescriber} from './descriptors/referralViewDescriptor/DescriptorType';
import Localized from 'src/constants/AppStrings';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import {useGlobalize} from '../../../i18n/hook/useGlobalize';

const styles = getDescriber().getStyleDescriptor();

const ReferralView = () => {
  const [referralCampaign, setIsReferralCampaign] = useState(false);
  const [referralStat, setIsReferralStat] = useState(false);
  const [amount, setAmount] = useState(0);
  const [referral, setReferral] = useState(0);
  const [signups, setSignups] = useState(0);
  const {formatCurrency} = useGlobalize();

  useEffect(() => {
    checkReferralStatus();
    FirebaseAnalytic.trackEvent('componentDidMount', 'ReferralView');
    AccountStore.addChangeListener(checkReferralStatus);
    return () => {
      AccountStore.removeChangeListener(checkReferralStatus);
    };
  }, []);

  //Checks Send A Snack Status based on User and Home location settings
  const checkReferralStatus = () => {
    const accountReferralCampaign = AccountStore.getReferralCampaign();
    const accountReferralStat = AccountStore.getReferralStat();
    if (
      accountReferralCampaign &&
      accountReferralStat &&
      !accountReferralCampaign.isDisabled
    ) {
      setIsReferralCampaign(true);
      setIsReferralStat(true);
      setAmount(AccountStore.getReferralCampaign().amount);
      setReferral(AccountStore.getReferralStat().referrals);
      setSignups(AccountStore.getReferralStat().signUps);
    } else {
      setIsReferralCampaign(false);
      setIsReferralStat(false);
      setAmount(0);
      setReferral(0);
      setSignups(0);
    }
  };

  //invite action
  const onInviteClick = () => {
    FirebaseAnalytic.trackEvent('onInviteClick', 'ReferralView');
    NavActions.navigate(AppRoutes.Referral, {
      referralCampaign: AccountStore.getReferralCampaign(),
      referralStat: AccountStore.getReferralStat(),
    });
  };
  const describerprops = {
    styles,
    onInviteClick,
    title: Localized.Labels.formatString(
      Localized.Labels.invite_frnd_referral,
      formatCurrency(amount, AccountStore.getCurrency())?.split('.')[0],
    ),

    stat: Localized.Labels.formatString(
      Localized.Labels.refer_sign_count,
      referral ?? 0,
      signups ?? 0,
    ),
    amount,
    isSnackEnabled:
      AccountStore.isConsumerSendSnackEnabled() &&
      AccountStore.isSendSnackEnabledForLocation(),
  };

  return referralCampaign && referralStat
    ? getDescriberCommon().referralViewDescriptor(
        describerprops,
        formatCurrency(
          describerprops.amount,
          AccountStore.getCurrency(),
        )?.split('.')[0],
      )
    : null;
};

export default ReferralView;
